module.exports = __webpack_public_path__ + "img/illustration-note.50d991b6.svg";